<template>
    <div class="gray-bg">

      <div class="middle-box text-center loginscreen animated fadeInDown">
        <div>
          <div><h1 class="logo-name">LS</h1></div>
        </div>

        <slot></slot>
      </div>

    </div>
</template>

<script>
    export default {
        name: "gray-bg"
    }
</script>

<style scoped>
body {
  background-color: #f3f3f4;
}
  .gray-bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/layout/GrayBg.vue